export function getFormUrl(): string {
  return 'https://readdy.ai/api/form/d9s92aknlsngrm4lmid0';
}